<template src="../templates/duplicateJob.html"></template>

<script>
import BookingModel from "../models/bookingModel";
import ContactModel from "../models/contactModel";
import JobsCollection from "../collections/jobsCollection";
import SearchJobDialog from "./SearchJobDialog";
import TimePicker from "./TimePickerCompomponent";
import moment from 'moment';

export default {
  name: "DuplicateJobComponent",
  data() {
    return {
      dynamicComponent: {
        data() {
          return {
            bookingModel: new BookingModel(),
          }
        },
        template: "<div></div>"
      },
      message: "",
      resultMessage: "",
      newRefNum: "",
      hasError: false,
      modalShow: false,
      modalResultShow: false
    }
  },
  methods: {
    hideModal() {
      this.$refs['modal-result'].hide();
    },
    reloadPage() {
      location.reload();
    },
    redirectToSearch() {
      this.$router.push({name: "SearchBooking", params: {jobId: this.newRefNum}});
    },
    actions() {
      let url = this.$localApiURL + 'layout/11?token=' + localStorage.getItem("jwt");
      this.$http.get(url, {
        headers: {"Bearer": localStorage.getItem("jwt")}
      }).then(result => {
          this.dynamicComponent = {
            components: {SearchJobDialog, TimePicker},
            data() {
              return {
                bookingModel: new BookingModel(),
                contactModel: new ContactModel(),
                jobsCollection: new JobsCollection(),
                jobsData: [],
                previousFormVisible: true,
                isNewBookingForm: false,
                currentRow: null,
                total: 0,
                pageSize: 7,
                currentPage: 1,
                loading: false,
                loadingLocations: false,
                emails: [],
                interpreters: [],
                interpretersTemp: [],
                languages: [],
                languagesTemp: [],
                clientLocations: [],
                clientLocationsTemp: [],
                clientDepartments: [],
                preferredTypePlaceHolder: "Select",
                caldGenders: [
                  {
                    value: 'M',
                    label: 'Male'
                  },
                  {
                    value: 'F',
                    label: 'Female'
                  }],
                genders: [
                  {
                    value: '',
                    label: 'Any'
                  },
                  {
                    value: 'M',
                    label: 'Male'
                  },
                  {
                    value: 'F',
                    label: 'Female'
                  }],
                genderPrefs: [
                  {
                    value: "",
                    label: ""
                  },
                  {
                    value: 'preferred',
                    label: 'Preferred'
                  },
                  {
                    value: 'must',
                    label: 'Must'
                  },
                ], jobTypes: [
                  {
                    value: "Inter",
                    label: "On Site Interpreting"
                  }, {
                    value: "Ph Int",
                    label: "Phone Interpreting"
                  }, {
                    value: "Video",
                    label: "Video Interpreting"
                  }],
                interpCatList: [],
                locationAddress1Default: true,
                address1Required: true,
                address2Required: false,
                dialogFormVisible: false,
                addressLabelName: "CLINIC",
                suburb: "",
                location_address1: "",
                location_address2: "",
                postCode: "",
                showClinicDropdown: false,

                countriesList: [],
                statesList: [],
                isDisabledState: false,
                isDisabledCountry: false,
                selectedCountryStr: '',
                selectedStateStr: ''
              }
            },
            watch: {
              'bookingModel.country_id': function (newVal, oldVal) {
                let localThis = this;
                  localThis.countriesList.forEach(detail => {
                    if(detail.id == newVal){
                        localThis.selectedCountryStr = detail.name;
                    }
                  });
              },
              'bookingModel.state_id': function (newVal, oldVal) {
                let localThis = this;
                  localThis.statesList.forEach(detail => {
                    if(detail.id == newVal){
                        localThis.selectedStateStr = detail.state_name;
                    }
                  });
              },

            },
            methods: {

              loadStates: function (country_id) {
                let url = this.$localApiURL + "dropdown/states/" + country_id;
                let localThis = this;
                this.$http.get(url, {
                  headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(function (response) {


                  localThis.statesList = response.data.data;

                  localThis.selectedStateStr = detail.state_name;

                }).catch(function (error) {
                  // handle error
                  console.log(error);
                });
              },

              loadCountries: async function () {
                let url = this.$localApiURL + "dropdown/countries";
                let localThis = this;

                try {
                  let response = await this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                  });

                  localThis.countriesList = response.data.data;

                  localThis.countriesList.forEach(detail => {
                    if(detail.id == 1){
                        localThis.bookingModel.country_id = detail.id;
                        localThis.selectedCountryStr = detail.name;
                    }
                  });

                } catch (error) {
                  console.error(error);
                }

                this.loadStates(1);
              },

              onChangeCountry: function() {
                let country_id = this.bookingModel.country_id;

                this.loadStates(country_id);
              },


              date: function (value, format) {
                if (value) {
                  return moment(String(value)).format(format || 'D MMMM YYYY')
                }
              },
              getServiceDate() {
                return this.bookingModel.serviceDate ? this.date(this.bookingModel.serviceDate, "D MMMM YYYY") : " ---";
              },
              getGenderPrefLabel() {
                let genderPref = this.genderPrefs.find(x => x.value === this.bookingModel.requested_gender_pref);
                if (genderPref != null && genderPref !== "") {
                  return genderPref.label;
                } else {
                  return ""
                }
              },
              getJobTypeLabel() {
                let jobType = this.jobTypes.find(x => x.value === this.bookingModel.jobType);
                if (jobType != null && jobType !== "") {
                  return jobType.label;
                } else {
                  return ""
                }
              },
              getGenderLabel() {
                let gender = this.genders.find(x => x.value === this.bookingModel.requestedGender);
                if (gender != null && gender !== "") {
                  return gender.label;
                } else {
                  return ""
                }
              },
              getInterpreterLabel() {
                if (this.interpreters !== undefined && this.interpreters !== "") {
                  let requestedInterpreter = this.interpreters.find(x => x.interpreterId === this.bookingModel.requestedInterpreter);
                  if (requestedInterpreter != null && requestedInterpreter !== "") {
                    return requestedInterpreter.interpreterName;
                  } else {
                    return ""
                  }
                }

              },
              setDefaultNoOfClients(noOfClients) {
                this.bookingModel.noOfClients = noOfClients;
              },
              setAsDefaultAddress2() {
                this.locationAddress1Default = false;
                this.address2Required = true;
                this.address1Required = false;
              },
              setDefaultJobType(jobType) {
                this.bookingModel.jobType = jobType;
              },
              setDefaultConfirmBy(confirmBy) {
                this.bookingModel.confirm_by = confirmBy;
              },
              setDefaultDepartment(department) {
                this.bookingModel.department = department;
              },
              setDefaultInterpCat(interpCat) {
                this.bookingModel.interpCat = interpCat;
              },
              setDefaultProfessional(professional) {
                this.bookingModel.professional = professional;
              },
              filterLanguages(query) {

                if (query !== '') {
                  this.loading = true;
                  setTimeout(() => {
                    this.loading = false;
                    this.languages = this.languagesTemp.filter(item => {
                      if (item != null && item.language != null) {
                        return item.language.toLowerCase()
                          .indexOf(query.toLowerCase()) > -1;
                      }
                      return false;
                    });
                  }, 200);
                } else {
                  this.languages = [];
                }
              },
              filterInterpreters(query) {

                if (query !== '') {
                  this.loading = true;
                  setTimeout(() => {
                    this.loading = false;
                    this.interpreters = this.interpretersTemp.filter(item => {
                      if (item != null && item.interpreterName != null) {
                        return item.interpreterName.toLowerCase()
                          .indexOf(query.toLowerCase()) > -1;
                      }
                      return false;
                    });
                  }, 200);
                } else {
                  this.interpreters = [];
                }
              },
              filterLocations(query) {
                if (query !== '') {
                  this.loading = true;
                  setTimeout(() => {
                    this.loadingLocations = false;
                    this.clientLocations = this.clientLocationsTemp.filter(item => {
                      if (item != null) {
                        return item.childName.toLowerCase()
                          .indexOf(query.toLowerCase()) > -1;
                      }
                      return false;
                    });
                  }, 200);
                } else {
                  this.languages = [];
                }
              },
              onChangeLocation() {

                let childId = this.bookingModel.locationId;
                let locationItem = this.clientLocationsTemp.filter(item => {
                  return item.childId === childId;
                });
                if (locationItem.length === 1 && this.bookingModel.isHomeVisit === false) {

                  this.bookingModel.locationName = locationItem[0].childName;
                  this.bookingModel.locationId = locationItem[0].childId;
                  if (this.locationAddress1Default) {
                    this.bookingModel.location_address1 = locationItem[0].location_address_1;
                    this.bookingModel.location_address2 = locationItem[0].location_address_2;
                  } else {
                    this.bookingModel.location_address1 = locationItem[0].location_address_2;
                    this.bookingModel.location_address2 = locationItem[0].location_address_1;
                  }
                  this.bookingModel.postCode = locationItem[0].postcode;
                  this.bookingModel.suburb = locationItem[0].suburb;
                }

                this.loadClientDepartments();
              },
              loadInterpCategories() {

                let url = this.$localApiURL + "clients/get/categories";
                let localThis = this;
                this.$http.get(url, {
                  headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(function (response) {
                  localThis.interpCatList = response.data;
                }).catch(function (error) {
                  console.log(error);
                });
              },
              loadContactEmails() {
                let url = this.$localApiURL + "contacts/getEmails";
                let localThis = this;
                this.$http.get(url, {
                  headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(function (response) {
                  localThis.emails = response.data;
                }).catch(function (error) {
                  console.log(error);
                });
              },
              loadInterpreters: function (filterByState = true) {
                if (this.bookingModel.language != null && this.bookingModel.language !== "") {
                  if (this.bookingModel.requestedInterpreter !== "") {
                    this.bookingModel.requestedInterpreter = ""
                  }
                  let url = this.$localApiURL + "interpreters/get/" + this.bookingModel.language + "/" + filterByState.toString();
                  let localThis = this;
                  this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                  }).then(function (response) {
                    //
                    localThis.interpreters = response.data;
                    localThis.interpretersTemp = response.data;

                  }).catch(function (error) {
                    console.log(error);
                  });
                }
              },
              loadLanguages: function () {
                let url = this.$localApiURL + "languages/get";
                let localThis = this;
                this.$http.get(url, {
                  headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(function (response) {

                  localThis.languages = response.data;
                  localThis.languagesTemp = response.data;

                }).catch(function (error) {
                  // handle error
                  console.log(error);
                });
              },
              loadClientLocations: function () {
                let url = this.$localApiURL + "clients/getLocations";
                let localThis = this;
                this.$http.get(url, {
                  headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(function (response) {
                  localThis.clientLocations = response.data;
                  localThis.clientLocationsTemp = response.data;

                }).catch(function (error) {
                  // handle error
                  console.log(error);
                });
              },
              loadClientDepartments: function () {
                let url = this.$localApiURL + "clients/getClientDepartments?child_id=" + this.bookingModel.locationId;
                let localThis = this;
                this.$http.get(url, {
                  headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(function (response) {

                  localThis.clientDepartments = response.data;

                  console.log('localThis.clientDepartments')
                  console.log(localThis.clientDepartments)
                  console.log(localThis.clientDepartments.length)

                  if (localThis.clientDepartments.length > 0)
                    localThis.showClinicDropdown = true;
                  else
                    localThis.showClinicDropdown = false;

                }).catch(function (error) {
                  // handle error
                  console.log(error);
                });
              },
              handleCurrentChange(val) {
                this.currentRow = val;

              },
              current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.paginate();
              },
              paginate: function () {

                let filteredData = this.jobsCollection.models;
                this.total = filteredData.length;
                if (this.total < this.pageSize) {
                  this.currentPage = 1;
                }
                this.jobsData = filteredData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);

              },
              loadPreviousJobs: function () {

                this.previousFormVisible = true;
              },
              chooseRecord: function () {
                this.bookingModel = new BookingModel();
                this.subscribeOnChangeModel();
                this.bookingModel.senderName = this.contactModel.name;
                this.bookingModel.phone = (this.contactModel.phone !== "") ? this.contactModel.phone : this.contactModel.clientPhone;
                this.bookingModel.email = this.contactModel.email;
                // this.bookingModel.email = (this.currentRow.email) != null ? this.currentRow.email : this.bookingModel.email;

                // this.bookingModel.senderName = (this.currentRow.senderName) != null ? this.currentRow.senderName : this.bookingModel.senderName;
                // this.bookingModel.location = (this.currentRow.location) != null ? this.currentRow.location : this.bookingModel.location;
                this.bookingModel.nebs = (this.currentRow.nesbs != null) ? this.currentRow.nesbs : this.bookingModel.nebs;
                this.bookingModel.mobile = (this.currentRow.mobile) != null ? this.currentRow.mobile : this.bookingModel.mobile;
                // this.bookingModel.phone = (this.currentRow.phone) != null ? this.currentRow.phone : this.bookingModel.phone

                this.bookingModel.language = (this.currentRow.language) != null ? this.currentRow.language : this.bookingModel.language;
                this.bookingModel.locationId = (this.currentRow.locationId) != null ? this.currentRow.locationId : this.bookingModel.locationId;
                this.bookingModel.locationName = (this.currentRow.locationName) != null ? this.currentRow.locationName : this.bookingModel.locationName;
                this.bookingModel.location_address2 = (this.currentRow.location_address2) != null ? this.currentRow.location_address2 : this.bookingModel.location_address2;
                this.bookingModel.location_address1 = (this.currentRow.location_address1) != null ? this.currentRow.location_address1 : this.bookingModel.location_address1;
                this.bookingModel.suburb = (this.currentRow.suburb) != null ? this.currentRow.suburb : this.bookingModel.suburb;
                this.bookingModel.postCode = (this.currentRow.postCode) != null ? this.currentRow.postCode : this.bookingModel.postCode;
                this.bookingModel.requestedGender = (this.currentRow.requestedGender) != null ? this.currentRow.requestedGender : this.bookingModel.requestedGender;
                this.bookingModel.jobType = (this.currentRow.jobType) != null ? this.currentRow.jobType : this.bookingModel.jobType;

                this.bookingModel.requestedInterpreter = (this.currentRow.requestedInterpreter) != null ? this.currentRow.requestedInterpreter : this.bookingModel.requestedInterpreter;
                this.bookingModel.requested_gender_pref = (this.currentRow.requested_gender_pref) != null ? this.currentRow.requested_gender_pref : this.bookingModel.requested_gender_pref;
                this.bookingModel.professional = (this.currentRow.professional) != null ? this.currentRow.professional : this.bookingModel.professional;
                this.bookingModel.additionalData = (this.currentRow.additionalData) != null ? this.currentRow.additionalData : this.bookingModel.additionalData;

                // Vic Roads fields start
                this.bookingModel.client_ref_no = (this.currentRow.client_ref_no) != null ? this.currentRow.client_ref_no : this.bookingModel.client_ref_no;
                this.bookingModel.interpretingCategory = (this.currentRow.interpretingCategory) != null ? this.currentRow.interpretingCategory : this.bookingModel.interpretingCategory;
                // Vic Roads fields end
                this.previousFormVisible = false;
                this.isNewBookingForm = true;
                this.$parent.message = "Data copied from selected job. Please check all entered data and update any information needed before submitting.";


                this.$parent.hasError = false;
                this.$parent.modalShow = true;
              },

              loadDetails: function () {
                this.contactModel = new ContactModel();
                let url = this.$localApiURL + this.contactModel.getRoute("fetch");
                this.contactModel.fetch({
                  'url': url,
                  params: {token: localStorage.getItem('jwt')}
                }).then(response => {
                  this.bookingModel.senderName = this.contactModel.name;
                  this.bookingModel.email = this.contactModel.email;
                  this.bookingModel.phone = (this.contactModel.phone !== "") ? this.contactModel.phone : this.contactModel.clientPhone;
                }).catch((error) => {
                  console.error(error);
                });
              },

              removeNesb(item) {
                let index = this.bookingModel.nebs.indexOf(item);
                if (index !== -1) {
                  this.bookingModel.nebs.splice(index, 1);
                }
              }
              ,
              addNesb() {
                this.bookingModel.nebs.push({
                  key: Math.random().toString(36).substr(2, 9),
                  value: '',
                  name: "",
                  reference: "",
                  gender: "",
                  when: "",
                  where: "",
                  professional: ""
                });
              },
              showPreview() {
                debugger;

                this.$refs["bookingModel"].validate((valid) => {

                  let errorExists = false;
                  this.bookingModel.validate().then(response => {
                    if (this.bookingModel.startTime > this.bookingModel.endTime) {
                      this.$parent.message = "Finish Time is earlier than Start Time, Please Fix";
                      this.$parent.hasError = true;
                      this.$parent.modalShow = true;
                    } else {
                      for (let item in this.bookingModel.errors) {
                        if (item != null) {
                          errorExists = true;
                          break;
                        }
                      }
                      if (!errorExists && valid) {
                        this.dialogFormVisible = true;
                      } else {

                        this.$parent.message = "Unable to submit booking. Required fields highlighted in red need to be entered.";
                        this.$parent.hasError = true;
                        this.$parent.modalShow = true;

                      }
                    }
                  }).catch(function (error) {
                    console.error(error);
                  });

                });

              },
              hidePreview() {
                this.dialogFormVisible = false;
              }
              ,
              bookJob() {
                let local = this;
                this.$refs["bookingModel"].validate((valid) => {
                  if (valid) {
                    let url = this.$localApiURL + this.bookingModel.getRoute("save");

                    // this.bookingModel.save({
                    //     'url': url,
                    //     params: {token: localStorage.getItem('jwt'), data: this.bookingModel}
                    // })

                    this.$http.post(url, {
                      token: localStorage.getItem("jwt"),
                      test: this.bookingModel
                    }).then(res => {

                      let data = res.data;
                      if (data != null && data.ref_num != null) {

                        this.$parent.resultMessage = "The booking '" + data.ref_num + "' has been successfully created";
                        this.$parent.newRefNum = data.ref_num;
                        this.$parent.modalResultShow = true;
                        this.$parent.hasError = false;
                        this.bookingModel = new BookingModel();
                        this.subscribeOnChangeModel();
                      } else if (data.error) {
                        this.$parent.message = data.message;
                        this.$parent.hasError = true;
                        this.$parent.modalShow = true;
                      } else {
                        this.$parent.message = "An error creating the booking has been occurred.";
                        this.$parent.hasError = true;
                        this.$parent.modalShow = true;
                      }

                      local.hidePreview();
                    }).catch(function (error) {

                      this.$parent.message = error;
                      this.$parent.hasError = true;
                      local.hidePreview();
                    });
                  }
                });
              },
              changePhoneInterpreting(jobTypeValue) {
                let phoneInterpreting = "Pre-Booked Phone Interpreting";
                let videoInterpreting = "Pre-Booked Video Interpreting";

                if (this.bookingModel.additionalData == null) {
                  this.bookingModel.additionalData = "";
                }

                this.bookingModel.additionalData = this.bookingModel.additionalData.replace(phoneInterpreting, "");
                this.bookingModel.additionalData = this.bookingModel.additionalData.replace(videoInterpreting, "");

                if (jobTypeValue === "Ph Int") {
                  this.bookingModel.additionalData += this.bookingModel.additionalData === "" ? phoneInterpreting : " " + phoneInterpreting;
                  this.loadInterpreters(false);
                } else if (jobTypeValue === "Video") {
                  this.bookingModel.additionalData += this.bookingModel.additionalData === "" ? videoInterpreting : " " + videoInterpreting;
                  this.loadInterpreters(false);
                } else {
                  this.loadInterpreters();
                }
              },
              clearLocationFields() {
                if (this.bookingModel.isHomeVisit === true) {
                  this.suburb = this.bookingModel.suburb;
                  this.location_address1 = this.bookingModel.location_address1;
                  this.location_address2 = this.bookingModel.location_address2;
                  this.postCode = this.bookingModel.postCode;

                  this.bookingModel.suburb = "";
                  this.bookingModel.location_address1 = "";
                  this.bookingModel.location_address2 = "";
                  this.bookingModel.postCode = "";
                  // this.address2Required = false;
                  this.$nextTick(() => this.$refs.address.focus());
                } else {
                  // this.address2Required = true;
                  this.bookingModel.suburb = this.suburb;
                  this.bookingModel.location_address1 = this.location_address1;
                  this.bookingModel.location_address2 = this.location_address2;
                  this.bookingModel.postCode = this.postCode;
                }
              },
              changePreferredGender(preferredType, requestedGender, oldPreferredType, oldRequestedGender) {

                if (requestedGender === "") {
                  this.preferredTypePlaceHolder = "Must select a preferred type";
                  this.bookingModel.requested_gender_pref = "";
                }
                if (oldPreferredType === "must") {
                  oldPreferredType = "must be";
                }
                if (preferredType !== undefined && preferredType !== '' && requestedGender !== undefined && requestedGender !== '') {
                  if (preferredType === "must") {
                    preferredType = "must be";
                  }
                  let newText = preferredType + " " + this.getGenderLabel() + " interpreter";
                  let oldGenderLabel = this.genders.find(x => x.value === oldRequestedGender);
                  if (oldGenderLabel !== undefined && oldGenderLabel !== '') {
                    let oldText = oldPreferredType + " " + oldGenderLabel.label + " interpreter";
                    if (this.bookingModel.additionalData !== undefined && this.bookingModel.additionalData !== '') {
                      this.bookingModel.additionalData = this.bookingModel.additionalData.replace(oldText, "");
                      this.bookingModel.additionalData += this.bookingModel.additionalData === "" ? newText : " " + newText;
                    } else {
                      this.bookingModel.additionalData += this.bookingModel.additionalData === "" ? newText : " " + newText;
                    }
                  }
                } else {
                  let oldGenderLabel = this.genders.find(x => x.value === oldRequestedGender);
                  if (oldGenderLabel !== undefined && oldGenderLabel !== '') {
                    let oldText = oldPreferredType + " " + oldGenderLabel.label + " interpreter";
                    if (this.bookingModel.additionalData !== undefined && this.bookingModel.additionalData !== '') {
                      this.bookingModel.additionalData = this.bookingModel.additionalData.replace(oldText, "");
                    }
                  }
                }
              }, subscribeOnChangeModel() {
                let localThis = this;
                this.bookingModel.on('change', (event) => {
                  //
                  switch (event.attribute) {
                    case "requestedGender":
                      let preferredType = localThis.bookingModel.requested_gender_pref;
                      localThis.changePreferredGender(preferredType, event.value, preferredType, event.previous);
                      break;
                    case "requested_gender_pref":
                      let requestedGender = localThis.bookingModel.requestedGender;
                      localThis.changePreferredGender(event.value, requestedGender, event.previous, requestedGender);
                      break;
                    case"jobType":
                      let jobTypeValue = localThis.bookingModel.jobType;
                      localThis.changePhoneInterpreting(jobTypeValue);
                      break;
                    case "language":
                      localThis.loadInterpreters();
                      break;
                    case "isHomeVisit":
                      localThis.clearLocationFields();
                      break;
                  }


                });
              }
            }, created() {

              console.log('DuplicateJob CREATED');

              this.loadStates();
              this.loadCountries();
              this.subscribeOnChangeModel();
              this.loadLanguages();
              this.loadContactEmails();
              this.loadClientLocations();
              this.loadDetails();

            }
            ,
            template: result.data,
          }
        }
      ).catch(function (error) {
        console.error(error);
      });
    },

  },
  created() {
    this.actions();

  }
  ,
}
</script>


<style>


/**

320px - iPhone 5/SE
360px - Galaxy S5
375px - iPhone X/6/7/8
414px - iPhone 6/7/8 Plus
480px
600px
768px - iPad
900px
1024px - iPad Pro
1200px

 */

.el-header {
  text-align: left;
  line-height: 60px;
}

.myPageForm-bookingForm {
  width: auto !important;
  padding: 0 0 0 0;
  background: #fff;
  -webkit-box-shadow: var(--myBox-shadow);
  box-shadow: var(--myBox-shadow);
}

.myPageForm-bookingForm label {
  font-weight: normal;
  text-align: left;
}

@media (min-width: 414px) {

  .myPageForm-bookingForm {
    margin: 48px 25px !important;
  }
}

@media (min-width: 1200px) {

  .myPageForm-bookingForm {
    margin: 48px 200px !important;;
  }
}

@media (min-width: 1480px) {

  .myPageForm-bookingForm {
    margin: 48px 400px !important;;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/DuplicateJobComponent.vue